export default __webpack_public_path__ + "static/media/family.a71a35d5.jpg";